import React, { useState } from "react";
import SiteChrome from "@/components/SiteChrome";
import { API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePlatformMessages } from "@/lib/usePlatformMessages";

export default function DiplomaIndividual() {
  const { t } = useI18n();
  const { m } = usePlatformMessages();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/diplomas/individual/download`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Erro");
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `diploma-${username}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(m("diploma_downloaded", null, "Diploma descarregado!"));
    } catch (e) {
      toast.error(e.message || m("diploma_download_error", null, "Não foi possível baixar o diploma"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteChrome>
    <div className="min-h-screen bg-slate-50 font-[Nunito]">
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="text-3xl font-[Fredoka] font-semibold text-slate-900 mb-2">{t("diploma_indiv")}</h1>
        <div className="bg-white border border-slate-200 rounded-3xl p-8 space-y-4 shadow-sm mt-6">
          <div>
            <Label>{t("username")}</Label>
            <Input data-testid="dip-username" value={username} onChange={(e) => setUsername(e.target.value.toUpperCase())} placeholder="S12345678" />
          </div>
          <div>
            <Label>{t("password")}</Label>
            <Input data-testid="dip-password" maxLength={4} value={password} onChange={(e) => setPassword(e.target.value.toUpperCase())} placeholder="ABCD" />
          </div>
          <Button data-testid="btn-dip-download" disabled={loading} onClick={download} className="w-full bg-amber-500 hover:bg-amber-600 rounded-full font-bold">
            {t("download_diploma")}
          </Button>
        </div>
      </div>
    </div>

    </SiteChrome>
  );
}
